import { LineChart, Line, XAxis, YAxis, Tooltip, ReferenceArea, ResponsiveContainer, CartesianGrid } from "recharts";

const fmt = (d) => new Date(d + "T00:00:00").toLocaleDateString(undefined, { month: "short", day: "numeric" });
const BAND_COLOR = { inspect: "#e11d48", optional: "#f59e0b", pass: "#059669" };

export function IssTrendChart({ history }) {
  if (!history || history.length < 2) return null;
  const first = history[0].date; const last = history[history.length - 1].date;
  const minV = history.reduce((m, h) => Math.min(m, h.iss), 100); const maxV = history.reduce((m, h) => Math.max(m, h.iss), 1);
  const lo = Math.max(0, Math.min(minV - 5, 45)); const hi = Math.min(100, Math.max(maxV + 5, 80));
  return (
    <div className="rounded-lg border bg-white" data-testid="fmcsa-iss-chart">
      <div className="px-3 py-2 border-b bg-slate-50 text-xs font-semibold flex flex-wrap gap-3 items-center">Estimated ISS — last 12 months
        <span className="font-normal text-slate-500 flex gap-3 ml-auto">{Object.entries(BAND_COLOR).map(([k, c]) => <span key={k} className="flex items-center gap-1"><span className="inline-block h-2 w-3 rounded-sm" style={{ background: c, opacity: 0.35 }} />{k === "inspect" ? "Inspect ≥75" : k === "optional" ? "Optional 50–74" : "Pass <50"}</span>)}</span>
      </div>
      <div className="h-56 p-2">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={history} margin={{ top: 8, right: 16, bottom: 0, left: -12 }}>
            <CartesianGrid stroke="#e2e8f0" vertical={false} />
            <ReferenceArea x1={first} x2={last} y1={75} y2={hi} fill={BAND_COLOR.inspect} fillOpacity={0.08} ifOverflow="hidden" />
            <ReferenceArea x1={first} x2={last} y1={50} y2={75} fill={BAND_COLOR.optional} fillOpacity={0.08} ifOverflow="hidden" />
            <ReferenceArea x1={first} x2={last} y1={lo} y2={50} fill={BAND_COLOR.pass} fillOpacity={0.08} ifOverflow="hidden" />
            <XAxis dataKey="date" tickFormatter={fmt} tick={{ fontSize: 11 }} minTickGap={32} />
            <YAxis domain={[lo, hi]} tick={{ fontSize: 11 }} allowDecimals={false} />
            <Tooltip labelFormatter={fmt} formatter={(v, _n, p) => [`${v} (${p.payload.band})`, "Estimated ISS"]} contentStyle={{ fontSize: 12 }} />
            <Line type="monotone" dataKey="iss" stroke="#1d4ed8" strokeWidth={2} dot={history.length <= 60 ? { r: 3, fill: "#1d4ed8" } : false} activeDot={{ r: 5 }} isAnimationActive={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
